export default __webpack_public_path__ + "static/media/dog3.d00f625c.svg";